import { Game } from "../../Game";
import { ScaleManager } from "../../Utils/ScaleManager";



export class ScreenOverlay {
    private _entity: pc.Entity;

    get opacity(): number { return this._entity.element.opacity; }
    set opacity(val: number) { this._entity.element.opacity = val; }

    get color(): pc.Color { return this._entity.element.color; }
    set color(val: pc.Color) { this._entity.element.color = val; }

    get enabled(): boolean { return this._entity.enabled; }
    set enabled(val: boolean) {
        if (this._entity.enabled != val) {
            this._entity.enabled = val;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0.5, 0.5, 0.5, 0.5],
            color: new pc.Color(0, 0, 0),
            opacity: 0.3,
        });
        this._entity.enabled = false;
        screen.addChild(this._entity);

        // Nastavit velikost a zachytavat zmenu rozliseni
        this.handleScreenResChange(Game.scale.width, Game.scale.height);
        Game.app.on(ScaleManager.EVENT_RESIZE, this.handleScreenResChange, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleScreenResChange(w: number, h: number): void {
        this._entity.element.width = w;
        this._entity.element.height = h;
        this._entity.setLocalPosition(-w / 2, -h / 2, 0);
    }
}